/*
document.addEventListener('_changeVariant', function(event) {
  //console.log('Variant change')
});
*/

/*
document.addEventListener('cartItems', function(event) {
  //console.log('Cart has been updated')
});
*/

// Prevent image change on variant selection
document.addEventListener('variant:change', function(event) {
    // Variant change image update ko override
    if (event.detail && event.detail.variant) {
        event.stopImmediatePropagation();
        console.log("Image changing prevented.");
    }
});

// Override Shopify image switch
if (window.Shopify && Shopify.Product) {
    Shopify.Product.prototype.switchImage = function() {
        console.log("Variant image switch stopped.");
    }
}
